export { mapAutocompleteResults } from './mapAutocompleteResults'
